import type { AssetsSegmentSchemaPatched } from '@iconik-io/iconik-api/src/schema_patched/assets_segments';
import {
  type AssetsHttpPostAssetsByAssetIdSegmentsHeader,
  httpPatchAssetsByAssetIdSegmentsBySegmentId,
  httpPostAssetsByAssetIdSegments,
} from '@iconik-io/iconik-api/src/services/assets';

export const SEGMENT_STATUS_AWAITED = 'AWAITED';

/**
 * A comment is created as an AWAITED draft so attachments can reference it
 * before it is sent. The list endpoint never returns drafts, but a draft still
 * reaches the store through its create response and through websocket messages.
 */
export const isAwaitedSegment = (segment: { status?: string | null }) =>
  segment.status === SEGMENT_STATUS_AWAITED;

export const postDraftCommentRequest = (
  assetId: string,
  body: AssetsSegmentSchemaPatched,
  headers?: AssetsHttpPostAssetsByAssetIdSegmentsHeader,
) =>
  httpPostAssetsByAssetIdSegments(
    assetId,
    { ...body, status: SEGMENT_STATUS_AWAITED },
    {},
    headers,
  );

/**
 * Sends a comment whose AWAITED draft already holds its attachments: the draft
 * takes the final content and turns ACTIVE instead of a second comment being
 * created.
 */
export function activateDraftCommentRequest(
  assetId: string,
  draftSegmentId: string,
  segment: AssetsSegmentSchemaPatched,
) {
  const { segment_type, asset_id, attachments, has_attachments, ...content } =
    segment;
  return httpPatchAssetsByAssetIdSegmentsBySegmentId(
    assetId,
    draftSegmentId,
    { ...content, status: 'ACTIVE' },
    { index_immediately: true },
  );
}
